import ApiService from '../api.services';

const ExportService = {
  export: async function (type, fields, file, delimiter, separador, header, customer, services, startedAt, finishedAt) {
    try {
      const data = {
        type, fields, file, delimiter, separador, header, customer, services, startedAt, finishedAt
      }
      const response = await ApiService.post('/api/export', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  boundary: async function (data) {
    try {
      const response = await ApiService.post(`/api/export/boundary`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  csv: async function (data, type, file) {
    try {
      const response = await ApiService.post(`/api/export/${file}/${type}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default ExportService;

export { ExportService };

